import React, { useState } from 'react'

const PlayersHeader = ({ selectedPlayers, setQuery, onRemovePlayer }) => {
  const [expanded, setExpanded] = useState(false)

  const removePlayer = (player) => {
    if (selectedPlayers.length == 1) setQuery('')
    onRemovePlayer(player)
  }

  const drawPlayers = () => {
    return <div className={'players' + (expanded ? ' expanded' : '')}>
      { selectedPlayers.map((player, i) => {
        const name = `${player.firstName} ${player.lastName}`
        return <div className='player-bubble' key={i}>
          <div className='bubble-title' title={player.phone}>{name}</div>
          <i className='fa fa-times' onClick={() => removePlayer(player)}></i>
        </div>
      })}
    </div>
  }

  return <div className='messages-cell chat-header'>
    <div className='chat-header-content'>
      {drawPlayers()}
      <i className={'fa expand ' + (expanded ? 'fa-angle-up' : 'fa-angle-down')} onClick={e => setExpanded(!expanded)}></i>
      <div className='selected-wrapper'>
        <div className='selected-player'>
          <div className='name'>
            {selectedPlayers.length} Players
          </div>
          {selectedPlayers.slice(0, 2).map(player =>
            <div className='avatar' key={player.id}>
              <img src={player.avatar || '/images/ic_user@2x.png'} />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
}

export default PlayersHeader
